import { getMarketSegment } from '../../utils';
import { MarketSegmentEnum } from '../../types';
import AmigoFooter from './AmigoFooter/AmigoFooter';
import VodafoneFooter from './VodafoneFooter/VodafoneFooter';

export default function Footer() {
    const isAmigo = getMarketSegment() === MarketSegmentEnum.AMIGO;

    return isAmigo ? (
        <AmigoFooter />
    ) : (
        <VodafoneFooter />
    );
}
